<template>
	<div v-bind:class="classListRow" class="gb-list-row" v-on:click.stop="toggleExpand">
		<div class="gb-list-row-item"
			v-bind:class="classListRowItemBorder"
			v-bind:style="styleListRowItem"
		>
			<div class="gb-list-row-item-inner" v-bind:style="styleInner">
				<div class="gb-list-row-item-left d-flex">
					<template v-if="!hasStatus">
						<template>
							<v-btn depressed class="btn-toggle">dummy</v-btn>
							<v-btn depressed class="btn-slide disabled"></v-btn>
						</template>
					</template>
					<template v-else>
						<template v-if="item.isProgress">
							<v-btn depressed color="error" class="btn-toggle" v-on:click.stop="setStatusDone" :disabled="!isEditable">完了に<br>する</v-btn>
							<v-btn depressed color="success" class="btn-slide" v-on:click.stop="toggleSlideRight">
								<template v-if="isSlided">未<br>完</template>
							</v-btn>
						</template>
						<template v-else>
							<v-btn depressed color="success" class="btn-toggle" v-on:click.stop="setStatusProgress" :disabled="!isEditable">未完に<br>する</v-btn>
							<v-btn depressed color="error" class="btn-slide" v-on:click.stop="toggleSlideRight">
								<template v-if="isSlided">完<br>了</template>
							</v-btn>
						</template>
					</template>
				</div>
				<div class="gb-list-row-item-content d-flex" v-bind:style="styleContent" v-bind:class="classSelectRow">
					<v-icon class="icon-subdirectory" v-if="isChild">subdirectory_arrow_right</v-icon>
					<div style="width: 0%;">
						<div class="name">{{ item.name }}</div>
						<GBClasses
							v-if="isShowClasses || !item.isProject"
							:items="outputClasses"
							:max_width="classesWidth()"
							:all_show=false
						/>
						<GBAdditionalInfo 
							v-if="isShowAdditionalInfo && item.isProject"
							:project="item"
							:project_pinned="project_pinned"
						/>
					</div>
				</div>
				<div class="gb-list-row-item-action d-flex" v-bind:class="classSelectRow">
					<template v-if="!isChild">
						<v-icon v-if="!isExpanded">expand_more</v-icon>
						<v-icon v-if="isExpanded">expand_less</v-icon>
					</template>
					<v-btn fab flat class="btn-slide"
						v-if="!narrow"
						v-bind:disabled="!isViewer"
						v-on:click.stop="toggleSlideLeft"
					><v-icon>more_horiz</v-icon></v-btn>
					<v-icon v-if="showAlertIcon" class="alert-icon">error</v-icon>
				</div>
				<div class="gb-list-row-item-right d-flex" v-if="isViewer && !narrow">
					<template v-if="isEditable">
						<v-btn depressed color="info" class="btn-add" v-if="canAddChild" v-on:click.stop="onShowAddMember">メンバー<br>追加</v-btn>
						<v-btn depressed color="warning" class="btn-edit" v-on:click.stop="onShowRightPane">編集</v-btn>
						<v-btn  v-if="isChild" depressed color="error" class="btn-del" v-on:click.stop="deleteMe">削除</v-btn>
					</template>
					<template v-else>
						<v-btn depressed color="info" class="btn-show" v-on:click.stop="onShowRightPane">参照</v-btn>
						<v-btn depressed color="purple darken-1" class="btn-show white--text" v-if="canUsePhoto" v-on:click.stop="onShowPhotoMng">写真</v-btn>
					</template>
				</div>
			</div><!-- gb-list-row-item-inner -->
		</div>
	</div>
</template>
<script>
import {SLIDE, FORM_MODE} from '../data/Const';
import ScheduleListRow from '../data/ScheduleListRow';
import GBClasses from './GBClasses';
import GBAdditionalInfo from './GBAdditionalInfo';
import ProjectPinned from '../data/ProjectPinned';

export default {
	name: 'GBScheduleListRow',
	props: [
		"item",
		"parent",
		"isEditable",
		"watchSlide",
		"narrow",
		"use_photo",
		"ghost_schedule",
		"project_pinned"
	],
	components: {
		GBClasses,
		GBAdditionalInfo,
	},
	data: function() {
		return {
			slide_status: SLIDE.STATUS.CENTER,
		};
	},
	methods: {
		toggleExpand: function() {
			this.toggleSlide(SLIDE.STATUS.CENTER);
			if (this.isChild)
				return;
			this.$store.dispatch('toggleExpand', {
				is_project: this.item.isProject,
				code: this.item.code,
			});
		},
		toggleSlide: function(direction) {
			if (this.slide_status === direction)
				this.slide_status = SLIDE.STATUS.CENTER;
			else {
				this.slide_status = direction;
				this.$emit('schedule-list-row-slide', {target: this.item, status: this.slide_status});
			}
		},
		toggleSlideLeft: function() {
			this.toggleSlide(SLIDE.STATUS.LEFT);
		},
		toggleSlideRight: function() {
			this.toggleSlide(SLIDE.STATUS.RIGHT);
		},
		contentWidth: function() {
			let width = 204;

			if (this.isChild) {
				width = 228;
			}

			return width;
		},
		classesWidth: function() {
			let width = this.contentWidth() - 11;

			if (this.isChild)
				width -= 21;

			return width;
		},
		setStatusDone: function() {
			this.$store.commit('setStatusDone', {
				self_code: this.item.code,
				parent_code: this.parent ? this.parent.code : undefined,
			});
			this.$emit('update-dataset');
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		setStatusProgress: function() {
			this.$store.commit('setStatusProgress', {
				self_code: this.item.code,
				parent_code: this.parent ? this.parent.code : undefined,
			});
			this.$emit('update-dataset');
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		deleteMe: function() {
			this.$emit('delete-member-from-project', {
				member: this.item,
				project: this.parent,
			});
		},
		onShowRightPane: function() {
			let mode = (this.isEditable) ? FORM_MODE.EDIT : FORM_MODE.REFERENCE;
			if(this.item.isProject){
				this.$emit("show-project-info", {project: this.item, mode: mode});
			}else if(this.item.isMember) {
				let member = this.$store.getters.mstMemberData(this.item.code);
				let target = {member: member, mode: mode};
				this.$emit("show-member-info", target);
			}
			this.toggleSlideLeft();
		},
		onShowAddMember: function() {
			this.$emit("show-add-member", this.item);
			this.toggleSlideLeft();
		},
		onShowPhotoMng: function() {
			let uri = '';
			if (this.item.isProject){
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.item.code;
			} else if (this.item.isMember) {
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/') + '/#' + this.item.code;
			}
			if (uri) {
				this.$router.push(uri);
			}
		},
	},
	computed: {
		height: function() {
			if (this.item.isProject) {
				let h = 49;
				
				let cnt = 0;
				if (this.project_pinned[ProjectPinned.TYPE.CLASS][ProjectPinned.PINNED_ID_CLASS] && !this.isWorkerRole) {
					cnt ++;
				}
				this.$store.getters.additionalInfo.forEach(add => {
					if (this.project_pinned[ProjectPinned.TYPE.ADDTIONAL][add.code]) {
						cnt ++;
					}
				});
				
				if (cnt > 0) {
					cnt -= 1;
				}
				
				h += (16 * cnt);
				
				return h;
			} else {
				return 49;
			}
		},
		classListRow: function() {
			let classes = new Array();

			if (!this.isChild)
				classes.push('parent');
			else
				classes.push('child');

			return classes;
		},
		classListRowItemBorder: function() {
			if (this.isChild)
				return 'gb-list-row-item-border';
			return '';
		},
		styleListRowItem: function() {
			return {
				height: this.height + 'px',
			};
		},
		styleInner: function() {
			let left = -80;
			if (this.slide_status == SLIDE.STATUS.RIGHT)
				left = this.isEditable ? 0 : -60;
			if (this.slide_status == SLIDE.STATUS.LEFT) {
				left = (this.isEditable && this.isChild) ? left - 120 : left -60;
				if (this.canAddChild)
					left -= 60;
				if (this.canUsePhoto)
					left -= 60;
			}

			return {
				left: left + 'px',
				transition: 'all .3s ease-in',
			};
		},
		styleContent: function() {
			let padding_left = 0.5;
			let width = this.contentWidth();

			if (this.isChild) {
				padding_left = 1;
			}

			return {
				'height': this.height + 'px',
				'width': width + 'px',
				'padding-left': padding_left + 'em',
			};
		},
		hasStatus: function() {
			return !(this.item.isMember && !this.isChild);
		},
		canAddChild: function() {
			return this.isEditable && this.item.isProject && !this.isChild;
		},
		canUsePhoto: function() {
			return !this.isEditable && this.use_photo && !this.isChild;
		},
		isSlided: function() {
			return this.slide_status !== SLIDE.STATUS.CENTER;
		},
		isExpanded: function() {
			return this.$store.getters.isExpandedScheduleListRow(this.item);
		},
		isChild: function() {
			return this.parent !== undefined;
		},
		showAlertIcon: function() {
			let alerts;
			if (this.$store.getters.isDisplayListTypeMember) {
				if (!this.isChild) {
					alerts = this.item.createOverlapSchedules(this.item.schedules);
				} else {
					alerts = this.parent.createOverlapSchedules(this.parent.schedules);
				}
			} else {
				if (!this.isChild) {
					alerts = this.item.createOverChildrenSchedules();
				} else {
					let all = new Array();
					this.$store.getters.projectList.forEach(p => {
						p.members.filter(m => { return m.code === this.item.code }).forEach(m => {
							m.schedules.forEach(s => {
								all.push(s);
							});
						});
					});
					alerts = ScheduleListRow.createOverlapSchedules(all, this.item.schedules);
				}
			}
			return alerts && alerts.length > 0;
		},
		isViewer: function() {
			return this.$store.getters.isViewer;
		},
		isWorkerRole: function() {
			return this.$store.getters.isWorkerRole;
		},
		outputClasses: function() {
			if (this.$store.getters.isWorkerRole) 
				return [];
			return this.item.classes;
		},
		classSelectRow: function() {
			if (this.ghost_schedule === undefined || this.ghost_schedule === null)
				return '';
			
			let classes = new Array();
			
			if (this.item.item_type === ScheduleListRow.ITEM_TYPE.PROJECT && !this.ghost_schedule.member_code) {
				if (this.ghost_schedule.project_code === this.item.code && this.parent !== null)
					classes.push('select-row');
			} else if (this.item.item_type === ScheduleListRow.ITEM_TYPE.MEMBER && this.ghost_schedule.member_code) {
				if (this.ghost_schedule.member_code === this.item.code && this.ghost_schedule.project_code === this.parent.code)
					classes.push('select-row');
			}

			return classes;
		},
		isShowClasses: function() {
			if (this.isWorkerRole) {
				return false;
			}
			if (!this.project_pinned)
				return true;
			
			return this.project_pinned[ProjectPinned.TYPE.CLASS][ProjectPinned.PINNED_ID_CLASS];
		},
		isShowAdditionalInfo: function() {
			if (!this.project_pinned)
				return true;
			let ret = false;
			for (let pinned_id in this.project_pinned[ProjectPinned.TYPE.ADDTIONAL]) {
				if (this.project_pinned[ProjectPinned.TYPE.ADDTIONAL][pinned_id]) {
					ret = true;
				}
			}
			
			return ret;
		},
	},
	watch: {
		isEditable: function() {
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		item: function() {
			this.slide_status = SLIDE.STATUS.CENTER;
		},
		watchSlide: function() {
			if (this.watchSlide.type === 'slide' && this.watchSlide.target === this.item)
				return;
			if (this.slide_status !== SLIDE.STATUS.CENTER)
				this.slide_status = SLIDE.STATUS.CENTER;
		},
	},
};
</script>
<style>
	.gb-list-row.parent {
		background-color: #fefefe;
	}

	.gb-list-row.child {
		background-color: #fbfbfb;
	}

	.gb-list-row-item {
		position: relative;
		flex: 1 1 auto;
		overflow: hidden;
		width: 299px;
	}
	.narrow .gb-list-row-item {
		width: 243px;
	}

	.gb-list-row-item-border {
		border-top: 1px solid #ffffff;
	}

	.gb-list-row-item-inner {
		display: flex;
		position: absolute;
		width: 613px;
	}

	.gb-list-row-item-left .btn-toggle {
		padding: .25em;
	}

	.gb-list-row-item-left .btn-slide {
		padding: .25em;
		min-width: 36px !important;
	}

	.gb-list-row-item-left .btn-slide.disabled {
		cursor: auto;
		background-color: gray !important;
		opacity: .5;
	}

	.gb-list-row-item-content {
		padding: .25em;
	}

	.gb-list-row-item-content .name {
		height: 1.5em;
		word-wrap: normal;
		overflow: hidden;
	}

	.gb-list-row-item-content .remarks {
		height: 1.1rem;
		color: #666;
		font-size: .75em;
		word-wrap: normal;
		overflow: hidden;
	}

	.gb-list-row-item-action {
		position: relative;
	}

	.gb-list-row-item-action .btn-slide {
		min-width: 36px !important;
	}

	.gb-list-row-item-right div {
		width: 16px;
	}

	.icon-subdirectory {
		font-size: 1em;
		align-items: baseline;
		flex: 0 0 auto !important;
	}
	
	.gb-list-row .select-row {
		background-color: rgba(0, 0, 0, .1);
	}
</style>
<style scoped>
	.v-btn {
		margin: 0;
		padding: 0;
		min-width: 60px;
		height: 100%;
		border-radius: 0;
		font-size: .75em;
	}

	.alert-icon {
		position: absolute;
		right: 3px;
		top: 0;
		opacity: .6;
		cursor: pointer;
		pointer-events: none;
		color: darkorange;
	}
</style>
